/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Faders(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M128.001,111.99988a8.00008,8.00008,0,0,0-8,8v96a8,8,0,0,0,16,0v-96A8.00008,8.00008,0,0,0,128.001,111.99988Z" />
        <Path d="M200.001,191.99988a7.99987,7.99987,0,0,0-8,8.00049l.001,16a8,8,0,0,0,16-.001l-.001-16A8,8,0,0,0,200.001,191.99988Z" />
        <Path d="M224.001,159.99988h-16l.001-120a8,8,0,1,0-16,0l-.001,120h-16a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
        <Path d="M56.001,159.99988a8.00039,8.00039,0,0,0-8,8l-.00049,48a8,8,0,0,0,16,0l.00049-48A8.00009,8.00009,0,0,0,56.001,159.99988Z" />
        <Path d="M80.001,127.99988h-16l-.00049-88a8,8,0,0,0-16,0l.00049,88h-16a8,8,0,0,0,0,16h48a8,8,0,1,0,0-16Z" />
        <Path d="M152.001,79.99988h-16v-40a8,8,0,1,0-16,0v40h-16a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      </G>
    </Svg>
  );
}

export default Faders;
